/**
 * Button can be customized with the following metadata properties:
 * - UIAppearance: can be set to 'flat' or 'stroked'
 * - UIColor: can be set to 'primary', 'accent' or 'warn (NOT IMPLEMENTED)
 * - ActionConfirmation: when button is clicked, confirmation dialog is shown
 *
 * Difference from BooleanButton: loading is not shown when button pressed.
 * */

import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { LoadingActions } from 'src/app/core/store/loading/loading.actions';
import { EntityPropertyBaseComponent } from '../entity-property-base/entity-property-base.component';

@Component({
  selector: 'app-entity-property-button',
  templateUrl: './entity-property-button.component.html',
  styleUrls: ['./entity-property-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EntityPropertyButtonComponent extends EntityPropertyBaseComponent<string> {
  constructor(private dialog: MatDialog, private store: Store) {
    super();
  }

  onClick() {
    const actionConfirmation = this.propertyType.MetaData['ActionConfirmation'];
    if (actionConfirmation !== undefined) {
      const textId = actionConfirmation;
      const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { textId } });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Start loading before debounce time in entity editor run out
          this.store.dispatch(LoadingActions.loading_start());
          this.propertyForm.setValue('clicked');
        }
      });
    } else {
      // Start loading before debounce time in entity editor run out
      this.store.dispatch(LoadingActions.loading_start());
      this.propertyForm.setValue('clicked');
    }
  }

  getUIAppearance() {
    const uiAppearanceMetadata = this.propertyType.MetaData['UIAppearance'];
    if (uiAppearanceMetadata !== undefined) {
      return uiAppearanceMetadata;
    }
    return 'flat';
  }
}
